export default "__VITE_ASSET__CT850f6e__"